import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ onLanguageChange }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const isEnglish = location.pathname.startsWith('/en');
  
  const switchLanguage = (lang) => {
    let newPath = location.pathname;
    
    const trToEnMap = {
      '/': '/en',
      '/hakkinda': '/en/about',
      '/projeler': '/en/projects',
      '/iletisim': '/en/contact',
      '/destek': '/en/support',
      '/yazilim-hizmetleri': '/en/software-services',
      '/yazilim-hesaplayici': '/en/software-calculator',
      '/cerez-politikasi': '/en/cookie-policy'
    };
    
    const enToTrMap = {
      '/en': '/',
      '/en/about': '/hakkinda',
      '/en/projects': '/projeler',
      '/en/contact': '/iletisim',
      '/en/support': '/destek',
      '/en/software-services': '/yazilim-hizmetleri',
      '/en/software-calculator': '/yazilim-hesaplayici',
      '/en/cookie-policy': '/cerez-politikasi'
    };
    
    if (lang === 'en') {
      if (!newPath.startsWith('/en')) {
        if (trToEnMap[newPath]) {
          newPath = trToEnMap[newPath];
        } else {
          const pathParts = newPath.split('/');
          if (pathParts.length > 1) {
            const basePath = '/' + pathParts[1];
            if (trToEnMap[basePath]) {
              newPath = trToEnMap[basePath] + (pathParts.length > 2 ? '/' + pathParts.slice(2).join('/') : '');
            } else {
              newPath = '/en' + newPath;
            }
          } else {
            newPath = '/en';
          }
        }
      }
    } else {
      if (newPath.startsWith('/en')) {
        if (enToTrMap[newPath]) {
          newPath = enToTrMap[newPath];
        } else {
          const pathParts = newPath.replace('/en', '').split('/');
          if (pathParts.length > 1 && pathParts[0] === '') {
            const basePath = '/en/' + pathParts[1];
            if (enToTrMap[basePath]) {
              newPath = enToTrMap[basePath] + (pathParts.length > 2 ? '/' + pathParts.slice(2).join('/') : '');
            } else {
              newPath = newPath.replace(/^\/en/, '');
              if (newPath === '') {
                newPath = '/';
              }
            }
          } else {
            newPath = newPath.replace(/^\/en/, '');
            if (newPath === '') {
              newPath = '/';
            }
          }
        }
      }
    }
    
    navigate(newPath);
    
    if (onLanguageChange) {
      onLanguageChange();
    }
  };

  return (
    <div className="language-switcher">
      <button 
        className={`lang-btn ${!isEnglish ? 'active' : ''}`}
        onClick={() => switchLanguage('tr')}
        aria-label="Türkçe"
      >
        TR
      </button>
      <button 
        className={`lang-btn ${isEnglish ? 'active' : ''}`}
        onClick={() => switchLanguage('en')}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
